import React from 'react';
import PropTypes from 'prop-types';
import {
  CSelect,
} from '@coreui/react';

const makeMatches = (max) => {
  const matchesArr = [];
  let i = 1;
  while (i <= max) {
    matchesArr.push({
      label: i,
      value: i,
    });
    i += 1;
  }
  return matchesArr;
};

const propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxSignatures: PropTypes.number,
  label: PropTypes.string,
  ignoreValues: PropTypes.arrayOf(PropTypes.any),
};

const defaultProps = {
  onChange: () => {},
  value: 1,
  maxSignatures: 5,
  label: '',
  ignoreValues: undefined,
};
const SignaturesSelect = ({
  onChange, value, maxSignatures, label, ignoreValues,
}) => {
  const [matches, setMatches] = React.useState(makeMatches(maxSignatures));
  const filteredMatched = ignoreValues
  // eslint-disable-next-line no-shadow
    ? matches.filter(({ value: val }) => val === value || !ignoreValues.includes(val))
    : matches;

  React.useEffect(() => {
    setMatches(makeMatches(maxSignatures));
  }, [maxSignatures]);

  return (
    <div>
      {label && (<div className="mb-1">{label}</div>)}
      <CSelect
        custom
        name="signatures"
        id="signatures"
        value={value}
        onChange={({ target }) => onChange(target.value)}
        className="mb-4 mxw-20rem mxw-100-xs"
      >
        <option value={0}>Select Option</option>
        {filteredMatched.map(((o) => (
          <option value={o.value} key={o.value}>{o.label}</option>
        )))}
      </CSelect>
    </div>
  );
};

SignaturesSelect.propTypes = propTypes;
SignaturesSelect.defaultProps = defaultProps;

export default React.memo(SignaturesSelect);
